angular.module('lsnBase.utils', ['lsnBase.arrayUnique']);